import MappingBase from './mappingBase.js';

class Service extends MappingBase {
  constructor({
    id = null,
    name = null,
    alias = null,
    description = null,
    duration = 30, // in minutes
    price = 0,
    currency = "MXN",
    categoryId = null,
    hierarchyCode = null,
    isActive = true,
    sortOrder = 0,
    pricingType = "fixed",
    isPopular = false,
    image = null,
    gallery = []
  } = {}) {
    super();
    this.id = id;
    this.name = name;
    // Salon-specific display name — surfaces must render alias || name
    // (the canonical homologation name is the fallback, never the preference).
    this.alias = alias;
    this.description = description;
    this.duration = duration;
    this.price = price;
    this.currency = currency;
    // Match the app and API policy; older blobs with only ctid keep working.
    this.categoryId = hierarchyCode || categoryId;
    this.hierarchyCode = hierarchyCode;
    this.isActive = isActive;
    this.sortOrder = sortOrder;
    this.pricingType = pricingType;
    this.isPopular = isPopular;
    this.image = image;
    // The service's own photo gallery (gal, #153) — URLs the salon uploaded in
    // the app; `image` stays the single cover.
    this.gallery = gallery || [];
  }

  static _aliasMapping = {
    id: "id",
    nm: "name",
    als: "alias",
    desc: "description",
    dur: "duration",
    pr: "price",
    cur: "currency",
    cid: "categoryId",
    ctid: "categoryId",
    uhhc: "hierarchyCode",
    ia: "isActive",
    so: "sortOrder",
    pt: "pricingType",
    ip: "isPopular",
    simg: "image",
    gal: "gallery"
  };
}

export default Service;
